<template>
  <div class="tipo-selector">
    <div class="header">
      <button type="button" class="btn-voltar" @click="$emit('voltar')">
        <fa-icon icon="arrow-left" /> Voltar
      </button>
      <h3>Que tipo de mapeamento?</h3>
      <p class="subtitle">Escolha a estratégia que melhor descreve como o valor será calculado.</p>
    </div>

    <div class="tipo-grid">
      <button
        v-for="t in tipos"
        :key="t.tipo"
        type="button"
        class="tipo-card"
        @click="$emit('selecionar', t.tipo)"
      >
        <div class="tipo-icone">
          <fa-icon :icon="t.icone" />
        </div>
        <div class="tipo-info">
          <div class="tipo-nome">{{ t.nome }}</div>
          <div class="tipo-desc">{{ t.descricao }}</div>
          <div class="tipo-exemplo"><code>{{ t.exemplo }}</code></div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TipoRegraSelector",
  data() {
    return {
      tipos: [
        {
          tipo: "simples",
          nome: "Campo simples",
          icone: "exchange-alt",
          descricao: "Pega o valor de um campo da Verso e envia direto para o ERP.",
          exemplo: "pedido.id  →  U_VS_PedidoEcommerce",
        },
        {
          tipo: "mapeamento",
          nome: "Mapeamento de valores",
          icone: "table",
          descricao: "Traduz cada valor de origem para um valor diferente (decision table).",
          exemplo: "1 → \"PF\"   ·   2 → \"PJ\"",
        },
        {
          tipo: "concatenacao",
          nome: "Concatenação",
          icone: "link",
          descricao: "Une vários campos e textos literais em um único valor.",
          exemplo: "logradouro + \", \" + numero",
        },
        {
          tipo: "coalesce",
          nome: "Primeiro disponível",
          icone: "list-ol",
          descricao: "Usa o primeiro campo da lista que tiver valor preenchido.",
          exemplo: "U_NORD_Order  ou  U_NORD_Ecommerce",
        },
        {
          tipo: "condicional",
          nome: "Condicional avançado",
          icone: "code-branch",
          descricao: "Define várias regras com condições e lógica E/OU para casos complexos.",
          exemplo: "se cobranca = 15 e valor > 5000 → \"APROVAR_MANUAL\"",
        },
      ],
    };
  },
};
</script>

<style scoped>
.tipo-selector {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.btn-voltar {
  background: none;
  border: none;
  color: #3a3e81;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 0;
  align-self: flex-start;
}
.btn-voltar:hover { text-decoration: underline; }
.header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1d2939;
  margin: 0;
}
.subtitle {
  font-size: 13px;
  color: #667085;
  margin: 0;
}
.tipo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 10px;
}
.tipo-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s;
}
.tipo-card:hover {
  border-color: #3a3e81;
  background: #fafbff;
  box-shadow: 0 2px 8px rgba(58, 62, 129, 0.08);
}
.tipo-icone {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #eceaf3;
  color: #3a3e81;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.tipo-info {
  flex: 1;
  min-width: 0;
}
.tipo-nome {
  font-weight: 600;
  font-size: 14px;
  color: #1d2939;
  margin-bottom: 2px;
}
.tipo-desc {
  font-size: 12px;
  color: #667085;
  margin-bottom: 6px;
  line-height: 1.4;
}
.tipo-exemplo {
  font-size: 11px;
}
.tipo-exemplo code {
  background: #f2f4f7;
  color: #475467;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Menlo', 'Consolas', monospace;
  font-size: 11px;
}
</style>
